import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=3cf6ff06&scoped=true"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js"
import style0 from "./SettingsNotifications.vue?vue&type=style&index=0&id=3cf6ff06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf6ff06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf6ff06')) {
      api.createRecord('3cf6ff06', component.options)
    } else {
      api.reload('3cf6ff06', component.options)
    }
    module.hot.accept("./SettingsNotifications.vue?vue&type=template&id=3cf6ff06&scoped=true", function () {
      api.rerender('3cf6ff06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccountSettings/SettingsNotifications.vue"
export default component.exports